import React from 'react';
export function Header() {
  return <header className="bg-blue-900 text-white py-2 sticky top-0 z-50" data-id="element-211">
      {/* Google Font Import */}
      <link href="https://fonts.googleapis.com/css2?family=Montserrat:wght@400;500;600;700;800&display=swap" rel="stylesheet" data-id="element-212" />
      <div className="max-w-6xl mx-auto px-2 sm:px-6 lg:px-8 flex justify-center items-center" data-id="element-213">
        <div className="flex items-center gap-4" data-id="element-214">
          <div className="text-sm font-bold" data-id="element-215">BABY FOOD MADE SIMPLE</div>
          <a href="#pricing" className="bg-yellow-500 hover:bg-yellow-400 text-blue-900 font-bold py-1 px-2 rounded-lg transition-colors" data-id="element-216">
            Download Now
          </a>
        </div>
      </div>
    </header>;
}